import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ConfigurarPastaServiceService } from 'app/configurar-pasta-service.service';

@Component({
  selector: 'app-incluir-uri-alfresco',
  templateUrl: './incluir-uri-alfresco.component.html',
  styleUrls: ['./incluir-uri-alfresco.component.scss']
})
export class IncluirUriAlfrescoComponent implements OnInit {

  uris : any[];
  orderForm: FormGroup;
  uriAlfresco = "";

  constructor(public service : ConfigurarPastaServiceService, private formBuilder: FormBuilder) { 
    
    service.getURIsAlfresco().subscribe(dados =>{
      this.uris = dados;
    })

  }

  ngOnInit() {
    this.orderForm = this.formBuilder.group({
      uri : String
    });
  }

  incluirURI(){
    if(this.uriAlfresco !== ""){
      this.orderForm.get("uri").setValue(this.uriAlfresco)
      this.service.salvarURIAlfresco(this.orderForm.value).subscribe(dados => {
        this.uris.push(dados)
        this.uriAlfresco = "";
      })

    }
    

  }

}



// WEBPACK FOOTER //
// /app/src/app/incluir-uri-alfresco/incluir-uri-alfresco.component.ts